import { useEffect } from 'react';
import { useConsent } from '../services/ConsentContextProvider';
import { isPrerender } from './pages/horeca/webgl';

const GA_ID = 'G-XHGGE7V3V9';
let gaLoaded = false;

// Exported only for test isolation (resets the module-level flag between tests).
export function __resetGaLoaded() { gaLoaded = false; }

function loadGA() {
  if (gaLoaded) return;
  gaLoaded = true;
  const s = document.createElement('script');
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  window.gtag = gtag;
  gtag('js', new Date());
  gtag('config', GA_ID);
}

function disableGA() {
  window[`ga-disable-${GA_ID}`] = true;
  const names = ['_ga', `_ga_${GA_ID.replace('G-', '')}`];
  names.forEach((name) => {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
    if (window.location && window.location.hostname) {
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=.${window.location.hostname}`;
    }
  });
}

// Headless. Injects GA4 only after Analytics consent; never under react-snap.
export const ConsentGate = () => {
  const { analytics } = useConsent();
  useEffect(() => {
    if (isPrerender()) return;
    if (analytics) loadGA();
    else if (gaLoaded) disableGA();
  }, [analytics]);
  return null;
};
